import React, { Component } from 'react'
import '../../Tablet/ContactUs/ContactUs.css';
import '../CostEstimateForm/form.css';
import { Link } from 'react-router-dom';


export default class ContactUs extends Component {
    render() {
        return (
                <>
                    <div className="container">
                        <form >
                            <div className="f-row">
                                <div className="f-column-12">
                                    <textarea style={{height:"150px"}} name="comment" placeholder="Comment.." ></textarea>
                                </div>
                            </div>
                            <div className="f-row">
                                <div className="f-column-6">
                                    <input  type="text" name="name" placeholder="Name (Required)"/>
                                </div>
                                <div className="f-column-6 top">
                                    <input  type="text" name="email" placeholder="Email (Required)"/>
                                </div>
                            </div>
                            <div className="f-row" style={{marginTop:'12px'}}>
                                <div className="f-column-6">
                                    <input  type="text" name="phone" placeholder="Phone Number (Required)"/>
                                </div>
                            </div>
                            <div className="form-button cpd-component cpd-component-wrapper" onClick={console.log("testing")}>
                                <div className="cpd-master-button-24ulab">
                                    <Link to="/">
                                        <div className="cpd-button-i2601281751-SgFFGf cpd-valign-text-middle">
                                            SEND MESSAGE
                                        </div>
                                    </Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
        )
    }
}
